
<h1>Elegí las fechas en las que querés viajar.</h1>

<p class="text-muted small">
  Seleccioná uno o más días disponibles
</p>

<p class="periodic-checkbox-wrapper">
  <label>
    Comprar Varios Pasajes
    <input type="checkbox"
           [ngModel]="multipleDates"
           (ngModelChange)="onMultipleDatesChange($event)">
  </label>
</p>

<div class="card-ui datepicker">

  <div class="datepicker-header row align-items-center mb-3">

    <button class="col-2 btn btn-light"
            (click)="previousMonth()"
            [disabled]="isCurrentMonth(currentMonth)">
      ←
    </button>

    <div class="col-8 text-center fw-semibold">
      {{ getMonthFullName(currentMonth) }} {{ currentMonth.year }}
    </div>

    <button class="col-2 btn btn-light"
            (click)="nextMonth()">
      →
    </button>

  </div>

  <div class="d-flex justify-content-between text-muted small mb-2 px-2">
    <span>DO</span><span>LU</span><span>MA</span><span>MI</span>
    <span>JU</span><span>VI</span><span>SA</span>
  </div>

  <ngb-datepicker
    #dp
    [minDate]="minDate"
    [markDisabled]="isDisabled"
    [dayTemplate]="dayTemplate"
    [showWeekdays]="false"
    [firstDayOfWeek]="7"
    (select)="onDateSelection($event)"
    (navigate)="currentMonth = $event.next"
    [navigation]="'none'">
  </ngb-datepicker>

  <button
    id="btn-checkout"
    class="btn btn-success btn-block btn-lg"
    *ngIf="validDate"
    routerLink="/steps/times">
    Continuar
  </button>

</div>

<ng-template #dayTemplate let-date>
  <span class="custom-day mono"
        [class.selected]="isSelected(date)"
        [class.gray]="isDisabled(date)"
        [class.past]="isPast(date)"
        [class.selectedButNA]="isSelected(date) && isDisabled(date)">
    {{ date.day }}
  </span>
</ng-template>